import { render, staticRenderFns } from "./ProjectActionsContainer.vue?vue&type=template&id=54440ee2&scoped=true"
import script from "./ProjectActionsContainer.vue?vue&type=script&lang=ts"
export * from "./ProjectActionsContainer.vue?vue&type=script&lang=ts"
import style0 from "./ProjectActionsContainer.vue?vue&type=style&index=0&id=54440ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54440ee2",
  null
  
)

export default component.exports